<!--  -->
<template>
  <v-os-popup
    :show="isShow"
    title="分期优惠"
    @close="close"
    :footerShow="false"
    class="vPopup"
    container="body"
    :height="isLowAndroid ? '80vh' : 'auto'"
  >
    <div class="installment-container" aria-hidden="false">
      <!-- 分期详情 -->
      <div class="table-container" :class="tabClass">
        <!-- 切换tab -->
        <div class="tab-area" :class="{ 'tab-area-two': tabNum == 2 }">
          <div
            class="tab-item"
            :class="{
              'left-selected': selectTab == 1 && tabNum == 2,
              'left-unselected': selectTab == 2 && tabNum == 2,
              'tab-one': tabNum == 1
            }"
            tabindex="0"
            v-if="huabeiPerInstallmentInfoList != 0"
            @click="changeTab(1)"
          >
            <img class="huaBei-img" src="./img/huaBei.png" :alt="selectTab == 1 ? '已选中,' : '未选中'" />
            <span :class="selectTab == 1 ? 'tab-title-selected' : 'tab-title-unselect'">花呗分期</span>
          </div>
          <div
            v-if="tabNum == 2"
            class="tab-middle"
            :class="selectTab == 1 ? 'tab-middle-left' : 'tab-middle-right'"
          ></div>
          <div
            class="tab-item"
            :class="{
              'right-selected': selectTab == 2 && tabNum == 2,
              'right-unselected': selectTab == 1 && tabNum == 2,
              'tab-one': tabNum == 1
            }"
            tabindex="0"
            v-if="bankInstallmentList.length != 0"
            @click="changeTab(2)"
          >
            <img class="creditCard-img" src="./img/creditCard.png" :alt="selectTab == 2 ? '已选中,' : '未选中'" />
            <span :class="selectTab == 2 ? 'tab-title-selected' : 'tab-title-unselect'">信用卡分期</span>
          </div>
        </div>
        <div class="tab-list" role="list" v-show="selectTab == 1">
          <div class="tab-list-item" role="listitem" v-for="(item, index) in huabeiPerInstallmentInfoList" :key="index">
            <span class="list-item-title" v-text="`￥${item.perPay} × ${item.num}期`"></span>
            <span class="huaBei-installment" v-if="item.userTotalFeePay == 0">免息，无手续费</span>
            <span class="huaBei-installment" v-else>含手续费</span>
          </div>
        </div>
        <div class="tab-list" role="list" v-show="selectTab == 2">
          <div class="tab-list-item" role="listitem" v-for="(item, index) in bankInstallmentList" :key="index">
            <img :src="item.bankLogoPic" alt="" />
            <span class="list-item-title" v-if="item.bankName" v-text="`${item.bankName}信用卡`"></span>
            <span class="list-item-title-1" v-if="item.userCard" v-text="`(${item.userCard})`"></span>
            <span class="bank-installment" v-text="item.label"></span>
          </div>
        </div>
      </div>
      <!-- 分期介绍 -->
      <div class="installment-introduce" @click="goStag()" tabindex="0">
        <span v-text="perInstallmentDesc"></span>
      </div>
    </div>
  </v-os-popup>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapState, mapGetters, mapActions } from 'vuex'
import { app } from '@/utils'
import env from '@/utils/clientEnv'
export default {
  name: 'InstallmentPopup',
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    //这里存放数据
    return {
      selectTab: 1,
      tabNum: 1,
      isLowAndroid: env.isLowAndroid
    }
  },
  //监听属性 类似于data概念
  computed: {
    ...mapState('detailv3', ['skuInfo', 'installment']),
    ...mapGetters('detailv3', ['skuId', 'discountType']),
    // 埋点参数page_name
    pageName() {
      return this.discountType == 'group' ? 2 : 1
    },
    //花呗分期
    huabeiPerInstallmentInfoList() {
      //按照分期数进行排序
      return this.installment?.detail?.hbInstallment?.perInstallmentInfoList || []
    },
    //银联分期
    bankInstallmentList() {
      return this.installment?.detail?.unionPayInstallment?.bankInstallmentList || []
    },
    //分期描述链接
    perInstallmentLink() {
      if (this.selectTab == 1) {
        return this.installment?.detail?.hbInstallment?.installmentLink
      } else {
        return this.installment?.detail?.unionPayInstallment?.installmentLink
      }
    },
    //分期描述
    perInstallmentDesc() {
      if (this.selectTab == 1) {
        return this.installment?.detail?.hbInstallment?.installmentDesc
      } else {
        return this.installment?.detail?.unionPayInstallment?.installmentDesc
      }
    },
    tabClass: function () {
      let result = ''
      if (this.tabNum == 1) {
        result = result + ' ' + 'table-container-one'
      }
      return result
    }
  },
  //监控data中的数据变化
  watch: {
    'installment.detail': {
      // 判断有几个tab页以及首次选中哪个tab
      handler: function (newValue, oldValue) {
        // 同时具备花呗和银联分期
        if (
          newValue?.hbInstallment?.perInstallmentInfoList?.length &&
          newValue?.unionPayInstallment?.bankInstallmentList?.length
        ) {
          this.tabNum = 2
        } else {
          if (newValue?.unionPayInstallment?.bankInstallmentList?.length) {
            this.selectTab = 2
          }
          this.tabNum = 1
        }
      },
      immediate: true
    },
    isShow: {
      handler: function (val) {
        if (val) {
          this.$track({
            cfrom: '176|002|02|077',
            event_id: '176|002|02|077',
            sku_id: this.skuId,
            page_name: this.pageName,
            tab_name: this.selectTab === 1 ? '花呗分期' : '银联分期'
          })
        }
      },
      immediate: true
    }
  },
  //方法集合
  methods: {
    track(type) {
      this.$track({
        cfrom: '176|002|01|077',
        event_id: '176|002|01|077',
        page_name: this.pageName,
        sku_id: this.skuId,
        click_Pos: type
      })
    },
    changeTab(val) {
      this.selectTab = val
      //埋点
      if (this.selectTab == 1) {
        //花呗tab
        this.track('1')
      } else {
        //信用卡tab
        this.track('2')
      }
    },
    close() {
      this.$emit('close')
    },
    goStag() {
      if (this.selectTab == 1) {
        //花呗分期文字链
        this.track('3')
      } else {
        //信用卡分期文字链
        this.track('4')
      }
      this.jump(this.perInstallmentLink)
    },
    jump(url) {
      app.openNewWebview({ url })
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" src="./index.scss" scoped></style>
<style lang="scss" scoped src="../../index/dark-popup.scss"></style>
